<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ (teamMember?.id ? 'misc.save_btn' : 'misc.create_btn') | translate }}
      </button>
    </div>
  </div>
</ng-template>

<div class="row g-3">
  <div class="col-12 col-md-9 order-md-1">
    <form [formGroup]="form" (submit)="save()">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.administration.team-members.edit.header' | translate }}
        </div>
        <div class="card-body">

          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.first_name"
                label="{{'authenticated.administration.team-members.edit.form.first_name.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.team-members.edit.form.first_name.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.last_name"
                label="{{'authenticated.administration.team-members.edit.form.last_name.label' | translate }}"
                [errorMessages]="{required: ('authenticated.administration.team-members.edit.form.last_name.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="readonlyFormValues.controls.ext_team_member_id"
                label="{{'authenticated.administration.team-members.edit.form.ext_team_member_id.label' | translate }}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.hello_one_page_slug"
                label="{{'authenticated.administration.team-members.edit.form.hello_one_page_slug.label' | translate }}"
              ></app-form-group>
            </div>

          </div>

        </div>
      </div>

    </form>
  </div>

  <div class="col-12 col-md-3 order-md-2">
    <form [formGroup]="form" (submit)="save()">
      <app-state-card formControlName="state"></app-state-card>
    </form>

    @if (teamMember) {
      <app-delete-card
        [disabled]="teamMember.state !== ModelStateEnum.DRAFT"
        *appIfHasAllPermissions="[PERMISSION.ADMINISTRATION_TEAMMEMBER_DELETE_ALL]"
        itemName="{{ 'authenticated.administration.team-members.delete.item' | translate }}"
        (deleteTriggered)="deleteItem()"
      ></app-delete-card>
    }
  </div>
</div>
